import { $Elements, Events } from './constants';

// ---------- Turnstile ----------

const Selectors = {
	widget: '[data-turnstile]',
};

// L'API Cloudflare est chargée en mode `render=explicit` : c'est à nous de
// monter les widgets. Elle appelle `tcTurnstileInit` une fois prête, mais rien
// ne garantit que ce soit avant ou après `page.enter` — les deux chemins mènent
// donc à `renderAll`, qui est idempotent.

let isApiReady = false;

window.tcTurnstileInit = () => {
	isApiReady = true;
	renderAll();
};

$Elements.document.on(Events.page.enter, () => {

	if(window.turnstile) {
		isApiReady = true;
	}

	if(isApiReady) {
		renderAll();
	}
});

// ---------- Rendu ----------

function renderAll() {

	if(typeof window.turnstile_params === 'undefined') {
		return;
	}

	document.querySelectorAll(Selectors.widget).forEach(renderWidget);
}

function renderWidget(element) {

	// Déjà monté : un second render() créerait un widget en double.
	if(element.dataset.turnstileId !== undefined) {
		return;
	}

	const widgetId = window.turnstile.render(element, {
		sitekey: window.turnstile_params.sitekey,
		language: window.turnstile_params.language,
		theme: 'light',
		size: 'flexible',
	});

	if(widgetId !== undefined) {
		element.dataset.turnstileId = widgetId;
	}
}

// ---------- Réinitialisation ----------

/**
 * Réarme les widgets pour permettre une nouvelle soumission.
 *
 * Un token est à usage unique : à n'appeler qu'une fois le token consommé
 * (soumission terminée ou refusée). Réinitialiser trop tôt viderait le champ
 * caché avant l'envoi.
 *
 * @param {Element|jQuery} [scope] Conteneur à réarmer. Toute la page si omis.
 */
export function resetTurnstile(scope) {

	if(!isApiReady || !window.turnstile) {
		return;
	}

	const root = (scope && scope.jquery) ? scope[0] : scope;
	const container = root || document;

	container.querySelectorAll(Selectors.widget).forEach(element => {

		if(element.dataset.turnstileId === undefined) {
			return;
		}

		window.turnstile.reset(element.dataset.turnstileId);
	});
}

// Exposé globalement pour le script inline d'ACF (functions/global/acf.php),
// qui n'est pas compilé dans ce bundle.
window.tcTurnstileReset = resetTurnstile;
